import { MaskedLines } from "./Reveal";

export const PageHero = ({ kicker, titleLines, intro }) => (
  <section className="pt-28 md:pt-36 pb-6 md:pb-10 border-b border-border" data-testid="page-hero">
    <div className="mx-auto max-w-7xl px-5 md:px-8">
      <p className="font-display font-bold tracking-widest text-xs md:text-sm text-terracotta mb-4">{kicker}</p>
      <h1 className="font-display font-extrabold tracking-tighter text-ink text-[12vw] leading-[1.08] sm:text-6xl md:text-7xl">
        <MaskedLines lines={titleLines} delay={0.1} />
      </h1>
      {intro && <p className="mt-5 max-w-2xl text-lg text-stone leading-relaxed">{intro}</p>}
    </div>
  </section>
);
